module.exports = __webpack_public_path__ + "static/media/image-card-3.bb74f852.png";